<template>
  <v-dialog
    v-model="isOpened"
    persistent
    scrollable
    width="600px"
  >
    <v-form @submit.prevent.native="submit">
      <v-card>
        <v-card-title>
          {{ title }}
          <v-spacer />
          <v-btn icon @click="closeDialog" v-if="canClose">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="py-3 px-4">
          <v-alert :value="true" type="info" v-if="message.length">
            {{ message }}
          </v-alert>
          <v-container class="py-2 px-0">
            <v-text-field
              v-model="email"
              label="Email"
              outlined
              autofocus
              color="primary darken-1"
            />
          </v-container>
        </v-card-text>
        <v-divider />
        <v-card-actions class="py-3 px-4">
          <v-spacer></v-spacer>
          <v-btn text @click="cancel">{{ cancelLabel }}</v-btn>
          <v-btn
            type="submit"
            color="primary darken-1"
            :loading="isSaving"
            :disabled="!isEmailValid"
          >
            {{ submitLabel }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import _ from 'lodash';

export default {
  props: {
    value: Boolean,
    maker: {
      type: Object,
      required: true,
    },
    canClose: {
      type: Boolean,
      required: false,
      default: false,
    },
    title: {
      type: String,
      required: false,
      default: `Ajouter un utilisateur`,
    },
    message: {
      type: String,
      required: false,
      default: ``,
    },
    submitLabel: {
      type: String,
      required: false,
      default: `Ajouter`,
    },
    cancelLabel: {
      type: String,
      required: false,
      default: `Annuler`,
    },
  },
  data: () => ({
    email: ``,
    isSaving: false,
  }),
  computed: {
    isOpened: {
      get() { return this.value; },
      set(value) { this.$emit(`input`, value); },
    },
    cleanEmail() {
      return _.trim(this.email);
    },
    isEmailValid() {
      return this.$isEmail(this.cleanEmail);
    },
  },
  methods: {
    initLocalState() {
      this.email = ``;
      this.isSaving = false;
    },
    async submit() {
      this.isSaving = true;
      const user = await this.$store.dispatch(`model/user/addMakerUserByEmail`, {
        email: this.email,
        makerId: this.maker.id,
      });
      this.isSaving = false;
      this.isOpened = false;
      this.$emit(`save`, user);
    },
    closeDialog() {
      this.isOpened = false;
      this.$emit(`close`);
    },
    cancel() {
      this.isOpened = false;
      this.$emit(`cancel`);
    },
  },
  watch: {
    isOpened(isOpened) {
      if (isOpened) {
        this.initLocalState();
      }
    },
  },
};
</script>
